import type { MaquetaPortada } from '@ahora-patagonia/contracts';

/**
 * Qué parte de la portada dibuja este render.
 *
 * Existe por una sola razón, y es de layout: en **escritorio** las maquetas B y C corren su frente
 * a ancho completo **por encima** del contenedor de dos columnas, así que Última hora arranca
 * debajo de la nota única (B) o de las dos grandes (C) en vez de acompañarlas desde arriba. El
 * frente se renderiza fuera de ese contenedor y el resto, adentro.
 *
 *  - `frente` — lo que va arriba, fuera de las dos columnas. Solo B y C, solo ≥1200.
 *  - `resto` — lo que queda en la columna principal: en C las tres chicas, en B nada.
 *  - `completa` — el bloque entero en el flujo. Es lo que se dibuja por debajo de 1200, donde no
 *    hay columna lateral y no hay nada que esquivar, y lo único que dibuja A en cualquier ancho.
 *
 * El corte lo hace CSS (`display` por breakpoint), como todo el resto del sitio: acá no se mide
 * nada ni se re-renderiza al cambiar de tamaño.
 */
export type PartePortada = 'completa' | 'frente' | 'resto';

/**
 * `true` si esa maqueta saca el frente del contenedor de dos columnas.
 *
 * A no: su frente vive dentro de la columna principal, que es lo que hace que Última hora arranque
 * a la misma altura que la portada.
 */
export function tieneFrentePropio(maqueta: MaquetaPortada): boolean {
  return maqueta !== 'A';
}

/**
 * `true` si, sacado el frente, a esa maqueta le queda algo para la columna principal.
 *
 * Solo C: sus tres chicas van debajo, al costado de Última hora. En B no queda nada —debajo de la
 * nota única no va más portada—, y saberlo acá es lo que evita que la home dibuje una franja vacía
 * con su padding en el lugar donde no hay bloque.
 */
export function tieneRestoBajoElFrente(maqueta: MaquetaPortada): boolean {
  return maqueta === 'C';
}
